// Right Chat - registro em tempo de execucao da tela do Kanban proprio.
//
// Substitui a rota kanban_view (Kanban pago original da fazer.ai) pela nossa tela
// nativa do Right Kanban, integrando diretamente ao menu lateral do Chatwoot.
import * as routerModule from '../routes';
import { rightKanbanRoutes } from '../routes/dashboard/rightKanban';

const ACCOUNT_WRAPPER_PATH = '/app/accounts/:accountId';
const KANBAN_PATH_FRAGMENT = '/kanban';

const resolveRouter = () => {
  const candidates = [routerModule.default, routerModule.router];
  return (
    candidates.find(
      candidate => candidate && typeof candidate.addRoute === 'function'
    ) || null
  );
};

const registerRoutes = router => {
  if (router.hasRoute('right_kanban_index') && router.hasRoute('kanban_board')) return true;

  if (router.hasRoute('kanban_view')) {
    router.removeRoute('kanban_view');
  }

  const roots = router.options?.routes || [];
  const wrapper = roots.find(
    route =>
      typeof route.path === 'string' &&
      route.path.replace(/\/+$/, '') === ACCOUNT_WRAPPER_PATH &&
      Array.isArray(route.children)
  );

  if (wrapper) {
    router.addRoute({
      path: wrapper.path,
      component: wrapper.component,
      children: rightKanbanRoutes,
    });
  } else {
    // eslint-disable-next-line no-console
    console.warn(
      '[right-kanban] wrapper de conta nao encontrado nas rotas; registrando no topo.'
    );
    rightKanbanRoutes.forEach(route => router.addRoute(route));
  }

  return router.hasRoute('kanban_view') || router.hasRoute('right_kanban_index');
};

const start = () => {
  const router = resolveRouter();
  if (!router) {
    // eslint-disable-next-line no-console
    console.error(
      '[right-kanban] router do dashboard nao encontrado; a tela nao foi registrada.'
    );
    return;
  }

  if (!registerRoutes(router)) return;

  // Se o carregamento inicial caiu na URL do kanban antes do registro
  const current = router.currentRoute?.value;
  if (current?.path?.includes(KANBAN_PATH_FRAGMENT) && !current.matched?.length) {
    router.replace(current.fullPath);
  }
};

if (typeof window !== 'undefined') start();
